<p>{{ 'app.addons.manage_validity_works' | translate }}!</p>
